export default (theme) => ({
    editorWrapper: {
        width: '100%',
        minHeight: 300,
        borderRadius: 4,
        overflow: 'hidden',
        border: `1px solid ${theme.colors.grey[100]}`,
        '&:focus-within': {
            borderColor: theme.colors.primary[500],
        },
    },
});
